function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.087 1.427L3.66 5 .087 8.573l1.34 1.34L5 6.34l3.573 3.573 1.34-1.34L6.34 5l3.573-3.573-1.34-1.34L5 3.66 1.427.087l-1.34 1.34z",
  fill: "#060505",
  fillRule: "nonzero"
});
function SvgFeatureClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgFeatureClose;